import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { DynamicFieldModel, Column, Item } from '@share';
import { LoadingService } from 'src/app/share/services/loading.service';
import { PostService } from './post.service';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { environment } from 'src/environments/environment';
import { SubcategoryService } from '../subcategory/subcategory.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CommonModule, DatePipe } from '@angular/common';
import { requireIfValueIs } from 'src/app/share/validators/dynamic-requiredIf-validator';
import { PostTitleService } from '../post-title/post-title.service';
import { forkJoin, Subject } from 'rxjs';
import { ExcelService } from 'src/app/share/services/excel.service';

const apiurl = environment.apiUrl;

@Component({
  selector: 'app-post',
  imports: [DynamicTableComponent, CommonModule],
  providers: [NzModalService, DatePipe],
  templateUrl: './post.component.html',
  styleUrl: './post.component.scss'
})
export class PostComponent implements OnInit {
  constructor(private datePipe: DatePipe, private readonly service: PostService, private readonly subcategoryService: SubcategoryService, private readonly loadingService: LoadingService, private readonly cdr: ChangeDetectorRef, private readonly modalService: NzModalService, private readonly postTitleService: PostTitleService, private readonly excelService: ExcelService) {

  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();

  }
  @HostListener('window:resize')
  calculateWidth() {
    const offsetWidth = 300;
    this.width = `${window.innerWidth - offsetWidth}px`;
  }
  ngOnInit(): void {
    this.calculateWidth();

    forkJoin({
      groups: this.service.getGroupItems(new HttpParams().set('type', 'User Post')),
      mainCategories: this.service.getMainCategoryItems(),
      categories: this.service.getCategoryItems(),
      subCategories: this.service.getSubCategoryItems(),
      postTitles: this.postTitleService.getItems(),
      post: this.service.getItems(),
    })
      .subscribe({
        next: ({ post, postTitles, groups, mainCategories, categories, subCategories }) => {

          this.schema.columns[1].option = post?.data
            .filter((post: any) => post.type === 'User Post' && post.createdType === 'user')
            .map((y: any) => ({
              text: y.content,
              value: y.content
            }))
            .filter((item: any, index: number, self: any[]) =>
              index === self.findIndex((t: any) => t.text === item.text && t.text)
            );

          // this.schema.columns[3].option = postTitles?.data.map((y: any) => ({
          //   text: y.title,
          //   value: y.title
          // }));

          this.schema.columns[3].option = groups?.data.map((y: any) => ({
            text: y.group_name,
            value: y.group_name
          }));

          this.schema.columns[4].option = mainCategories?.data
            ?.filter((y: any) => y.type === 'User Post' && y.createdType === 'user')
            .map((y: any) => ({
              text: y.maincategory_name,
              value: y.maincategory_name
            }));

          // this.schema.columns[6].option = categories?.data
          //   ?.filter((y: any) => y.type === 'User Post' && y.createdType === 'user')
          //   .map((y: any) => ({
          //     text: y.category_name,
          //     value: y.category_name
          //   }));



          this.fieldConfig[1].options = groups?.data.map((y: any) => ({
            text: y.group_name,
            value: y.id
          }));

          // this.fieldConfig[6].options = postTitles?.data.map((y: any) => ({
          //   value: y.id,
          //   text: y.title
          // }));
        },
        error: err => console.error('Error loading options:', err),
        complete: () => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        }
      });
  }
  width: string;
  total = 0;
  schema = {
    name: "User Post List",
    permissionKey: "post",
    enableDelete: true,
    enableEdit: true,
    enableAdd: false,
    enableDownload: false,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: false,
        isStickyLeft: true,

      },
      {
        key: "imageUrl",
        title: "Image",
        type: "image",
        width: "100px",
        isStickyRight: false,
        isStickyLeft: false,

      },
      // {
      //   key: "product_name",
      //   title: "Product Name",
      //   type: "string",
      //   enableSearch: true,
      //   searchType: "input",
      //   //enableSort: true,
      //   width: "200px",
      //   isStickyRight: false,
      //   isStickyLeft: false,
      // },
      {
        key: "content",
        title: "Content",
        type: "string",
        enableSearch: true,
        //enableSort: true,
        searchType: "input",
        // option: [] as any[],
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,

      },
      // {
      //   key: "type",
      //   title: "Post Type",
      //   type: "string",
      //   enableSearch: true,
      //   //enableSort: true,
      //   searchType: "input",
      //   width: "100px",
      //   isStickyRight: false,
      //   isStickyLeft: false,

      // },
      // {
      //   key: "title_name",
      //   title: "Post Title",
      //   type: "string",
      //   enableSearch: true,
      //   //enableSort: true,
      //   searchType: "select",
      //   option: [] as any[],
      //   width: "200px",
      //   isStickyRight: false,
      //   isStickyLeft: false,

      // },
      {
        key: "group_name",
        title: "Group Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "maincategory_name",
        title: "Main Category Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      // {
      //   key: "category_name",
      //   title: "Category",
      //   type: "string",
      //   enableSearch: true,
      //   searchType: "select",
      //   option: [] as any[],
      //   width: "260px",
      //   isStickyRight: false,
      //   isStickyLeft: false,
      // },
      // {
      //   key: "subcategory_name",
      //   title: "Sub Category Name",
      //   type: "string",
      //   enableSearch: true,
      //   searchType: "select",
      //   option: [] as any[],
      //   width: "260px",
      //   isStickyRight: false,
      //   isStickyLeft: false,
      // },
      // {
      //   key: "createdType",
      //   title: "Created By",
      //   type: "string",
      //   enableSearch: true,
      //   searchType: "select",
      //   option: [{ value: "user", text: "User" }, { value: 'admin', text: "Admin" }],
      //   width: "200px",
      //   isStickyRight: false,
      //   isStickyLeft: false,
      // },
      {
        key: "status",
        title: "Status",
        type: "tag",
        enableSearch: true,
        searchType: "select",
        option: [
          { value: "draft", text: "Draft" },
          // { value: "scheduled", text: "Scheduled" },
          { value: "published", text: "Published" }
        ],
        width: "180px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight: true,
        isStickyLeft: false,
        label: [
          { name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }
        ]//,{name:"delete",type:"danger"}
      }
    ]
  };

  report = {
    name: "Post Report",
    file_name: "Post_Report",
    header: [
      {
        label: "No",
        fieldName: "no",
        tag: "no",
        width: 5
      },
      {
        label: "Post Id",
        fieldName: "id",
        class: "align-left",
        width: 30
      },
      {
        label: "Content",
        fieldName: "content",
        class: "align-left",
        width: 30
      },
      // {
      //   label: "Post Title",
      //   fieldName: "title_name",
      //   class: "align-left",
      //   width: 30
      // },
      {
        label: "Group Name",
        fieldName: "group_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Main Category Name",
        fieldName: "maincategory_name",
        class: "align-left",
        width: 30
      },
      // {
      //   label: "Category Name",
      //   fieldName: "category_name",
      //   class: "align-left",
      //   width: 30
      // },
      // {
      //   label: "Sub Category Name",
      //   fieldName: "subcategory_name",
      //   class: "align-left",
      //   width: 30
      // },
      {
        label: "Created By",
        fieldName: "createdType",
        class: "align-left",
        width: 20
      },
      {
        label: "Status",
        fieldName: "status",
        class: "align-left",
        width: 20
      },
      // {
      //   label: "Scheduled Date",
      //   fieldName: "scheduled_date",
      //   class: "align-left",
      //   width: 30,
      // },
    ]
  };


  fieldConfig: Array<DynamicFieldModel> = [
    {
      name: 'image',
      type: 'multi-image-file',
      label: 'Upload Image',
      readonly: false,
      required: false,
    },
    {
      label: 'Group Name',
      name: 'group_id',
      type: 'select',
      required: true,
      placeholder: 'Group Name',
      optionUrl: 'categoryhierarchy/options',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Group Name required',
        },
      ],
    },
    {
      label: 'Main Category Name',
      name: 'maincategory_id',
      type: 'select',
      required: true,
      placeholder: 'Main Category Name',
      dependOn: 'group_id',
      matchType: 'User Post',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Main Category Name required',
        },
      ],
    },
    // {
    //   label: 'Category Name',
    //   name: 'category_id',
    //   type: 'select',
    //   required: false,
    //   placeholder: 'Category Name',
    //   dependOn: 'maincategory_id',
    //   optionUrl: 'categoryhierarchy/option',
    //   options: [
    //   ],
    //   // validations: [
    //   //   {
    //   //     name: 'required',
    //   //     validator: Validators.required,
    //   //     message: 'Category Name required',
    //   //   },
    //   // ],
    // },
    // {
    //   label: 'Sub Category Name',
    //   name: 'subcategory_id',
    //   type: 'select',
    //   required: true,
    //   placeholder: 'Sub Category Name',
    //   dependOn: 'category_id',
    //   optionUrl: 'categoryhierarchy/option',
    //   options: [
    //   ],
    //   validations: [
    //     {
    //       name: 'required',
    //       validator: Validators.required,
    //       message: 'Sub Category Name required',
    //     },
    //   ],
    // },
    {
      label: 'Product Name',
      name: 'product_name',
      // type: 'input',
      sortOrder: 1,
      placeholder: '',
      required: false,
      readonly: true,
      hideByField: 'type',
      hideByFieldValue: 'User Post',
      type: 'hidden',

      // validations: [
      //   {
      //     name: 'required',
      //     validator: Validators.required,
      //     message: 'Product Name required',
      //   },
      // ],
    },

    {
      label: 'Content',
      name: 'content',
      type: 'quill-text',
      class: 'col-md-6',
      placeholder: 'Content',
      required: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Content required',
        },
      ],
    },

    // {
    //   label: 'Title',
    //   name: 'title',
    //   type: 'select',
    //   placeholder: 'Select Title',
    //   required: false,
    //   options: [],
    //   // validations: [
    //   //   {
    //   //     name: 'required',
    //   //     validator: Validators.required,
    //   //     message: 'Title is required',
    //   //   }
    //   // ],
    // },
    {
      label: 'Status',
      name: 'status',
      type: 'select',
      class: 'col-md-6',
      placeholder: 'Select Status',
      required: true,
      options: [
        { value: 'draft', text: 'Draft' },
        // { value: 'scheduled', text: 'Scheduled' },
        { value: 'published', text: 'Published' },
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Status required',
        },
      ],
    },
    // {
    //   label: 'Schedule Date',
    //   name: 'scheduled_date',
    //   type: 'dateTime',
    //   class: 'col-md-6',
    //   placeholder: 'Select scheduled date',
    //   hideByField: 'status',
    //   hideByFieldValue: 'draft,published',
    //   showPicker: true,
    //   minDate: new Date(),
    //   dependOn: 'status',
    //   validations: [
    //     {
    //       name: 'requiredIf',
    //       validator: requireIfValueIs('status', 'scheduled'),
    //       message: 'Scheduled Date is required when status is Scheduled',
    //     }
    //   ]
    // },
    {
      label: 'Post Type',
      name: 'type',
      type: 'hidden',
      value: 'User Post'
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },

  ];

  list: any[] = [];

  listOfData: Item[] = [];
  loading = false;
  pageSize = 10;
  pageIndex = 1;
  searchValue = '';
  currentTime: Date = new Date();
  private searchSubject = new Subject<string>();

  getCellValue(row: any, column: Column): string {
    // Handle image column to show first image
    if (column.fieldName === 'image') {
      if (row.image && Array.isArray(row.image) && row.image.length > 0) {
        return row.image[0].url || row.image[0];
      }
      return '';
    }

    if (column.fieldName === "eng_version") {
      if (row[column.fieldName]) {

        return 'mm , en';
      }
      else {
        return 'mm'
      }
    }
    if (!row[column.fieldName.split('.')[0]]) return ''
    const result: string = column.fieldName
      .split('.')
      .reduce((prev: any, curr: string) => prev[curr], row)
    if (column.pipe) {
      switch (column.pipe) {
        case 'shortDateTime': {
          console.log(this.datePipe.transform(result));
          return this.datePipe.transform(result)
        }
      }
    }

    return result
  }
  change(data: { [key: string]: any }) {
    console.log('Change event data:', data);
    if (data['type'] == 'download') {
      console.log('Download triggered');
      // Add type to filters for download
      let filters = data['filters'] || {};
      filters.type = 'User Post';
      filters.createdType = 'user';

      let params = new HttpParams()
        .set('filterValue', JSON.stringify(filters));
      this.loadingService.toggleTableLoading()
      this.service.getItems(params).subscribe({
        next: x => {


          console.log('Download response:', x);
          //this.list = x.data;
          let data = x.data;
          console.log('Original data length:', data?.length);
          if (data !== undefined && data.length !== 0) {
            const value = []
            for (let i = 0; i < data?.length; i++) {
              // if (this.report.header.length === 0) {
              //   this.report.header = Object.keys(data[i])
              // }
              const item: any = {}
              for (const row of this.report.header) {
                const head = row
                if (!head.hasOwnProperty('objFieldName')) {
                  if (head.tag === 'no') item[head.label] = i + 1
                  else if (head.tag === 'number')
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : 0
                  else if (head.tag === 'pipe') {
                    const [field1, field2] = head.fieldName.split('|');
                    const value = data[i][field1];
                    item[head.label] = value !== '' && value != null
                      ? value
                      : data[i][field2] ?? '';
                  }
                  else if (head.tag === 'datetime') {
                    item[head.label] = data[i][head.fieldName]
                      ? this.datePipe.transform(new Date(data[i][head.fieldName]), 'dd-MM-yyyy HH:mm')
                      : ''
                  }
                  else
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : ''
                } else {
                  item[head.label] =
                    data[i][head.fieldName] !== null
                      ? this.getCellValue(data[i], head)
                      : ''
                }
              }
              value.push(item)
            }
            const dynamicName = `${this.report.file_name
              }_${this.currentTime.getDate()}_${this.currentTime.getMonth() + 1
              }_${this.currentTime.getFullYear()}`;
            console.log('Exporting Excel with:', { value, dynamicName, header: this.report.header });
            this.excelService.exportAsExcelFile(
              value,
              dynamicName,
              this.report.header
            )
          } else {
            console.log('No data to export');
          }
        },
        error: err => this.loadingService.toggleTableLoading(),
        complete: () => this.loadingService.toggleTableLoading()
      });
    }
    else {
      let params = new HttpParams()
        //.set('searchValue',this.searchValue)
        .set('page', data['pageIndex'].toString())
        .set('pageSize', data['pageSize'].toString())
        .set('filterValue', JSON.stringify(data['filters']))
        .set('sort', JSON.stringify(data['sorts']));
      this.loadData(params);
    }
  }

  loadData(param: HttpParams = null, needLoading: boolean = true) {
    if (needLoading) {
      this.loadingService.toggleTableLoading();
    }

    // Add type filter to ensure we only get User Posts from the backend
    let params = param || new HttpParams();

    if (params.has('filterValue')) {
      try {
        let filterValue = JSON.parse(params.get('filterValue'));
        filterValue.type = 'User Post';
        filterValue.createdType = 'user';
        params = params.set('filterValue', JSON.stringify(filterValue));
      } catch (e) {
        // If parsing fails, create new filterValue with type
        params = params.set('filterValue', JSON.stringify({ type: 'User Post', createdType: 'user' }));
      }
    } else {
      // If no filterValue exists, create one with type
      params = params.set('filterValue', JSON.stringify({ type: 'User Post', createdType: 'user' }));
    }

    this.service.getItems(params).subscribe({
      next: x => {
        this.list = x.data || [];

        this.list.forEach(item => {
          item.imageUrl = Array.isArray(item.image) && item.image.length > 0
            ? item.image[0].url || item.image[0]
            : '';

          this.list = (x.data || []).map((item: any) => {

            item.imageUrl = Array.isArray(item.image) && item.image.length > 0
              ? item.image[0].url || item.image[0]
              : '';

            if (item.scheduled_date) {
              const d = new Date(item.scheduled_date);
              item.scheduled_date = !isNaN(d.getTime()) ? d : item.scheduled_date;
            }
            else {
              item.scheduled_date = null;
            }

            return item;
          });
        });
        this.total = x.totalCount || 0;
      },

      error: err => {
        console.error(err);
        this.loadingService.toggleTableLoading();
      },
      complete: () => {
        this.loadingService.toggleTableLoading();
        this.cdr.detectChanges();
      }

    });
  }

  formEvent(data: any) {

    if (data.id) {
      if (data.title === null || data.title === 'null') {
        data.title = null;
      }
      if (data.category_id === null || data.category_id === 'null') {
        data.category_id = null;
      }
      this.loadingService.toggleTableLoading();
      // --- Proper scheduled_date handling ---
      if (data.status === 'scheduled') {

        if (data.scheduled_date && data.scheduled_date !== 'null') {
          const d = new Date(data.scheduled_date);

          if (!isNaN(d.getTime())) {
            data.scheduled_date = d.toISOString();
          } else {
            delete data.scheduled_date;
          }
        } else {
          delete data.scheduled_date;
        }
      } else {
        delete data.scheduled_date;
      }
      this.service.updateItem(data).subscribe({
        next: x => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params, false);
        },
        error: err => {
          console.error('Update post error:', err);
          this.loadingService.toggleTableLoading();
        }
      });
    }
    else if (data.deleted_id) {
      // this.loadingService.toggleTableLoading();
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.loadingService.toggleTableLoading();
          this.service.deleteItem(data).subscribe({
            next: x => {
              let params = new HttpParams()
                .set('page', this.schema.pageIndex.toString())
                .set('pageSize', this.schema.pageSize.toString());
              this.loadData(params, false);
            },
            error: err => {
              console.log(err);
              this.loadingService.toggleTableLoading();
            }

          });
        },
        nzOnCancel: () => {
          this.loadingService.toggleTableLoading();
        }
      });
    }
    else {
      this.loadingService.toggleTableLoading();
      if (data.title === '') {
        delete data.title; // convert empty string to null
      }

      const formData = new FormData();

      Object.keys(data).forEach(key => {
        let value = data[key];

        if (key === 'scheduled_date') {
          if (data.status === 'scheduled' && value) {
            const dateObj = new Date(value);
            if (!isNaN(dateObj.getTime())) {
              formData.append(key, dateObj.toISOString());
            }
          }
          return;
        }
        // Append value only if it's not undefined
        if (value !== undefined) {
          formData.append(key, value);
        }
      });
      // append image **File** (not JSON)
      if (data.image) {
        const images = Array.isArray(data.image) ? data.image : [data.image];
        images.forEach((img: any) => {
          formData.append('image', img.originalFile);
        });
      }

      // Create post
      this.service.createItem(formData).subscribe({
        next: x => {
          const params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params, false);
        },
        error: err => {
          console.error('Create post error:', err);
          this.loadingService.toggleTableLoading();
        }
      });
    }
  }
  reloadTable() {
    const params = new HttpParams()
      .set('page', this.schema.pageIndex.toString())
      .set('pageSize', this.schema.pageSize.toString());

    this.loadingService.toggleTableLoading();
    this.loadData(params, false);
  }
}